/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import styled, { css } from 'styled-components';

/**
 * Internal dependencies
 */
import { useStory } from '../../../app/story';
import StoryFontPicker from '../../storyFontPicker';

const StyledFontPicker = styled(StoryFontPicker)`
  width: 164px;
`;

const listStyleOverrides = css`
  max-height: 200px;
`;
const containerStyleOverrides = css`
  border: 1px solid ${({ theme }) => theme.colors.border.defaultNormal};
`;
function FontFamily() {
  const { selectedElements } = useStory(({ state }) => ({
    selectedElements: state.selectedElements,
  }));

  return (
    <StyledFontPicker
      tabIndex={-1}
      listStyleOverrides={listStyleOverrides}
      containerStyleOverrides={containerStyleOverrides}
      selectedElements={selectedElements}
    />
  );
}

export default FontFamily;
